import { useActiveLocation } from '@/features/organization-locations';
import { useClaireDesigner } from '@/features/public-sites/claire-designer-flag';
import { PublicSiteBuilder } from '@/features/public-sites/public-site-builder';
import { Navigate } from '@tanstack/react-router';
export function PublicSitePage({
  locationId,
  handoffToken,
}: { locationId: string; handoffToken?: string }) {
  const { enabled, loading } = useClaireDesigner();

  const { location } = useActiveLocation();
  if (loading) return null;
  if (!enabled)
    return (
      <Navigate
        to="/dashboard/l/$locationId/venue"
        params={{ locationId }}
        replace
      />
    );
  return location ? (
    <PublicSiteBuilder
      key={location.id}
      locationId={location.id}
      handoffToken={handoffToken}
    />
  ) : null;
}
